"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchematicInstanceTracker = void 0;
class SchematicInstanceTracker {
    constructor(sourceFile, projectConfigUtil) {
        this.sourceFile = sourceFile;
        this.projectConfigUtil = projectConfigUtil;
        this.usedInstanceNumbers = new Map();
        this.usedPathInstanceNumbers = new Map();
    }
    claimNextChannelIndex(channelPrefix, startingIndex) {
        const usedInstanceNumbers = this.usedInstanceNumbers.get(channelPrefix) ?? new Set();
        while (usedInstanceNumbers.has(startingIndex)) {
            startingIndex++;
        }
        usedInstanceNumbers.add(startingIndex);
        this.usedInstanceNumbers.set(channelPrefix, usedInstanceNumbers);
        return startingIndex;
    }
    claimPreferredOrLowestAvailableChannelIndex(channelPrefix, preferredIndex) {
        if (preferredIndex <= 0) {
            throw new Error(`Preferred channel index must be positive, received ${preferredIndex}`);
        }
        const usedInstanceNumbers = this.usedInstanceNumbers.get(channelPrefix) ?? new Set();
        let claimedIndex = preferredIndex;
        if (usedInstanceNumbers.has(claimedIndex)) {
            claimedIndex = 1;
            while (usedInstanceNumbers.has(claimedIndex)) {
                claimedIndex++;
            }
        }
        usedInstanceNumbers.add(claimedIndex);
        this.usedInstanceNumbers.set(channelPrefix, usedInstanceNumbers);
        return claimedIndex;
    }
    setClaimedChannelIndex(channelPrefix, index) {
        const usedInstanceNumbers = this.usedInstanceNumbers.get(channelPrefix) ?? new Set();
        if (usedInstanceNumbers.has(index)) {
            throw new Error(`Channel index ${index} is already in use for prefix ${channelPrefix}`);
        }
        usedInstanceNumbers.add(index);
        this.usedInstanceNumbers.set(channelPrefix, usedInstanceNumbers);
    }
    claimNextSheetIndexInPath(parentInstance, thisHierarchy, startingIndex) {
        const path = parentInstance.pathUniqueId;
        if (parentInstance.path.length >= thisHierarchy.hierarchyIndex && !this.usedPathInstanceNumbers.has(path)) {
            const pathParts = path.split('\\');
            const parentPath = pathParts.slice(0, thisHierarchy.hierarchyIndex).join('\\');
            const currentParent = this.usedPathInstanceNumbers.get(parentPath);
            this.usedPathInstanceNumbers.set(path, new Set(currentParent));
        }
        const usedInstanceNumbers = this.usedPathInstanceNumbers.get(path) ?? new Set();
        while (usedInstanceNumbers.has(startingIndex)) {
            startingIndex++;
        }
        usedInstanceNumbers.add(startingIndex);
        this.usedPathInstanceNumbers.set(path, usedInstanceNumbers);
        return startingIndex;
    }
}
exports.SchematicInstanceTracker = SchematicInstanceTracker;
//# sourceMappingURL=SchematicInstanceTracker.js.map